import { render, staticRenderFns } from "./photo-opacity.vue?vue&type=template&id=7c6846e0&scoped=true&"
import script from "./photo-opacity.vue?vue&type=script&lang=js&"
export * from "./photo-opacity.vue?vue&type=script&lang=js&"
import style0 from "./photo-opacity.vue?vue&type=style&index=0&id=7c6846e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6846e0",
  null
  
)

export default component.exports